export default __webpack_public_path__ + "static/npcc-dde434239b248baa7835d43dca05a40c.png";